import { render } from "./MainLayout.vue?vue&type=template&id=3fceee86&ts=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=3fceee86&lang=css"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__